/* eslint-disable */
import request from './helpers'

export function listAllLongSubTasks (page, size) {
    return request ({
        url: '/api/v1/longTask/longSubTask/all/search',
        method: 'get',
        params: {
            page, size
        }
    })
}

export function downloadLongSubTasksResult (data) {
    return request ({
        url: '/api/v1/longTask/longSubTask/result/download',
        responseType:'blob',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export function searchLongSubTasks (page, size, data) {
    return request ({
        url: '/api/v1/longTask/longSubTask/search',
        method: 'post',
        params: {
            page, size
        },
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export function deleteLongSubTasks (data) {
    return request ({
        url: '/api/v1/longTask/longSubTask/delete',
        method: 'delete',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export function downloadUploadTopicResult (data) {
    return request ({
        url: '/api/v1/topic/result/uploadTopic/download',
        responseType:'blob',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}
